// Dispatch table mapping a block's flat "printableKind" (the same keys
// TournamentPrintableTable.js's own renderer switch already uses:
// "schedule" | "groups" | "participants" | "results" | "brackets") to its
// vector measure/draw/content-width/asset-preload functions, so
// TournamentExportModal.js can stay a thin orchestrator instead of
// branching on block type itself.
import {
    CONTENT_WIDTH_MM as PARTICIPANTS_WIDTH_MM,
    measureParticipantsTable, drawParticipantsTable, preloadParticipantsAssets,
} from "./pdfParticipantsTable";
import {
    CONTENT_WIDTH_MM as RESULTS_WIDTH_MM,
    measureResultsTable, drawResultsTable,
} from "./pdfResultsTable";
import { scheduleContentWidthMm, measureScheduleTable, drawScheduleTable } from "./pdfScheduleTable";
import { groupsContentWidthMm, measureGroupsTables, drawGroupsTables } from "./pdfGroupsTables";
import { bracketTreeContentWidthMm, measureBracketTree, drawBracketTree } from "./pdfBracketTree";

const noPreload = async () => ({});

export const PDF_RENDERERS = {
    participants: {
        contentWidthMm: () => PARTICIPANTS_WIDTH_MM,
        measure: (data, grade) => measureParticipantsTable(data, grade),
        draw: (pdf, x, y, data, grade, i18n, extra) => drawParticipantsTable(pdf, x, y, data, grade, extra?.flagMap),
        preload: (data, grade) => preloadParticipantsAssets(data, grade),
    },
    results: {
        contentWidthMm: () => RESULTS_WIDTH_MM,
        measure: (data, grade) => measureResultsTable(data, grade),
        draw: (pdf, x, y, data, grade) => drawResultsTable(pdf, x, y, data, grade),
        preload: noPreload,
    },
    schedule: {
        contentWidthMm: (data) => scheduleContentWidthMm((data?.courts || []).length),
        measure: (data) => measureScheduleTable(data),
        draw: (pdf, x, y, data, grade, i18n) => drawScheduleTable(pdf, x, y, data, grade, i18n),
        preload: noPreload,
    },
    groups: {
        contentWidthMm: (data) => groupsContentWidthMm(Array.isArray(data) ? data : (data?.groups || [])),
        measure: (data) => measureGroupsTables(data),
        draw: (pdf, x, y, data, grade) => drawGroupsTables(pdf, x, y, data, grade),
        preload: noPreload,
    },
    brackets: {
        contentWidthMm: (data) => bracketTreeContentWidthMm(Array.isArray(data) ? data : (data?.draws || [])),
        measure: (data) => measureBracketTree(Array.isArray(data) ? data : (data?.draws || [])),
        draw: (pdf, x, y, data, grade, i18n) => drawBracketTree(pdf, x, y, data, grade, i18n),
        preload: noPreload,
    },
};
